import cache from "@/libs/cache";
export default {
  setUserInfo(state, data) {
    state.userInfo = data;
    cache.set(cache.CACHE_KEY.USERINFO, state.userInfo);
  },
  setToken(state, data) {
    state.token = data;
    cache.set(cache.CACHE_KEY.TOKEN, state.token);
  },
  /**登出 */
  loginOut(state) {
    state.token = null;
    state.userInfo = null;
    state.role = null;
    state.calculateRole = false;
    cache.clear();
  },
  /**计算权限 */
  calculateRole(state) {
    var userInfo = state.userInfo;
    state.calculateRole = true;
    if (!userInfo) {
      state.role = null;
      state.redictRouter = { path: "/login" };
      return;
    }
    var roleList = userInfo.roleList;
    if (roleList && roleList.length) {
      roleList.map((role, index) => {
        if (0 == index) {
          state.role = role;
        }
      });
      var redict = userInfo.defaultPassword ? { path: "/updatepwd" } : null;
      state.redictRouter = redict;
    } else {
      state.role = null;
      state.redictRouter = { path: "/login" };
    }
  },
  /**设置字典信息 */
  setDicts(state, data) {
    state.dict = data;
    let dicts = JSON.parse(JSON.stringify(data));
    for (let i in dicts) {
      dicts[i].unshift({ code: "All", name: "全部" });
    }
    state.dictAll = dicts;
  },
  /**清除重定向路由 */
  clearRedictRouter: state => {
    state.redictRouter = null;
  }
};
